import { create } from 'zustand';

const useUserData = create((set) => ({
  user: null,

  updateUser: (data) => set({ user: data }),
  deleteUser: () => set({ user: null }),
}));

export default useUserData;
